import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BuildX from "./BuildX";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<BuildX />} />
        <Route path="*" element={<BuildX />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
